import { Component } from '@grafikr/components';
import { NonNullish } from 'utils/nullish-check';
import wishlist from 'utils/wishlist/wishlist';

export default Component((node) => {
  const data = {
    handle: NonNullish(node.dataset.handle),
    id: parseInt(NonNullish(node.dataset.id), 10),
  };

  const toggleClass = (add?: boolean) => {
    node.classList.toggle('active', add);
  };

  const toggle = async () => {
    toggleClass();
    await wishlist.api.toggleItem(data);

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: {
        count: wishlist.api.getItems().length,
      },
    }));
  };

  node.addEventListener('wishlist:updated', () => {
    toggleClass(wishlist.api.hasItem(data));
  });

  node.addEventListener('click', toggle);

  toggleClass(wishlist.api.hasItem(data));
});
